import slashSeparatedISODateToISODate from './slashSeparatedISODateToISODate';
import isoDateIsValid from './isoDateIsValid';
import dateToISODate from './dateToISODate';
export default function fromStringToIsoDate(dateString) {
    let result = undefined;
    // if dataString of pattern 'YYYY-MM-DD' is passed, it will return the same string
    // if dataString of pattern 'YYYY-MM-DDTHH:MM:SS' is passed, it will return YYYY-MM-DD
    if (dateString.length === 10) {
        result = slashSeparatedISODateToISODate(dateString);
        if (isoDateIsValid(result)) {
            return result;
        }
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return undefined;
    }
    return dateToISODate(date);
}
